import moment from 'moment';

// Returns true if shift duration is 8 hours or more
const validateClockOut = (clockInDateTime) => {
  const diffMinutes = moment().diff(moment(clockInDateTime), 'minutes');

  return diffMinutes >= 480;
};

export default validateClockOut;
